import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@shadcn/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@shadcn/components/ui/tabs';
import { PlusIcon, Zap, Clock, History } from 'lucide-react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import automationApi from '../services/automationApi';

import DashboardStats from '../components/Dashboard/DashboardStats';
import RuleList from '../components/Dashboard/RuleList';
import ExecutionList from '../components/Execution/ExecutionList';

const AutomationDashboardPage = () => {
  const user = JSON.parse(localStorage.getItem('authUser') || '{}');
  const canView = Array.isArray(user?.permissions) && user.permissions.includes('ViewAutomations');

  const [activeTab, setActiveTab] = useState('rules');
  const [statsKey, setStatsKey] = useState(0);
  const [ruleOptions, setRuleOptions] = useState([]);

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const rules = await automationApi.getRulesForSelect();
        setRuleOptions((rules || []).map(r => ({ value: r._id, label: r.name || r._id, triggerType: r.trigger?.type })));
      } catch (e) {
        setRuleOptions([]);
      }
    };
    fetchRules();
  }, [statsKey]);

  const handleRuleChange = () => setStatsKey(k => k + 1);

  if (!canView) {
    return (
      <div className="page-content">
        <div className="text-center py-12 text-gray-500">You do not have permission to view this page.</div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="w-full px-3 mx-auto xl:max-w-[85%]">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h4 className="text-2xl font-bold">Automation Engine</h4>
            <p className="text-sm text-gray-500 mt-1">Create and manage automated workflows</p>
          </div>
          <Link to="/automation-engine/rules/create">
            <Button>
              <PlusIcon className="h-4 w-4 mr-2" />
              New Rule
            </Button>
          </Link>
        </div>

        <DashboardStats refreshKey={statsKey} />

        <Tabs value={activeTab} onValueChange={setActiveTab} className="mt-6">
          <TabsList>
            <TabsTrigger value="rules" className="flex items-center gap-1.5">
              <Zap size={14} />
              Rules
            </TabsTrigger>
            <TabsTrigger value="schedules" className="flex items-center gap-1.5">
              <Clock size={14} />
              Schedules
            </TabsTrigger>
            <TabsTrigger value="executions" className="flex items-center gap-1.5">
              <History size={14} />
              Executions
            </TabsTrigger>
          </TabsList>

          <TabsContent value="rules" className="mt-4">
            {activeTab === 'rules' && <RuleList onRuleChange={handleRuleChange} ruleOptions={ruleOptions} />}
          </TabsContent>

          <TabsContent value="schedules" className="mt-4">
            {activeTab === 'schedules' && <RuleList onRuleChange={handleRuleChange} defaultTriggerType="schedule" ruleOptions={ruleOptions.filter(r => r.triggerType === 'schedule')} />}
          </TabsContent>

          <TabsContent value="executions" className="mt-4">
            {activeTab === 'executions' && <ExecutionList ruleOptions={ruleOptions} />}
          </TabsContent>
        </Tabs>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AutomationDashboardPage;
